import request from '../../utils/request';

export const activiti_interface = {
    getModels: (params) => {
        return request({
            url: '/repository/models',
            method: 'get',
            params: params
        })
    },getDeployments: (params) => {
        return request({
            url: '/repository/deployments',
            method: 'get',
            params: params
        })
    },getDeplymentList: (params) => {
        return request({
            url: '/activiti/service/deployments',
            method: 'get',
            params: params
        })
    },
    deploy: (id) => {
        return request({
            url: '/activiti/service/models/deploy',
            method: 'put',
            params: {id: id}
        })
    },
    updateUser: (params) => {
        return request({
            url: '/users',
            method: 'put',
            data: params
        })
    },
    sendRequest: (params) => {
        return request({
            url: "/cookie/auth/setup",
            method: 'get',
        })
    }
}
